import { IProjectUsageInfo } from '../ServerApi/types/IUsageInfo';
import {
  IControlledPermissionItemInfo,
  ICreatedItemInfo,
  IDescriptionItemInfo,
  IExplorableItemTypeInfo,
  IFavoriteItem,
  IItemStatisticsInfo,
  INamedChildItemInfo,
  INamedItemInfo,
  IOwnedItemInfo,
  ISpaceTypeInfo,
  IUpdatedItemInfo,
  ILuidItemInfo,
} from './resourceInfoParts';

export interface IProjectBase extends
  ICreatedItemInfo,
  IDescriptionItemInfo,
  INamedItemInfo,
  IOwnedItemInfo,
  INamedChildItemInfo,
  IUpdatedItemInfo,
  IExplorableItemTypeInfo<'project'>,
  ISpaceTypeInfo<'project'>,
  IFavoriteItem,
  IControlledPermissionItemInfo,
  ILuidItemInfo
{
  topLevelProject: boolean;
}

export interface IProjectInfo extends IProjectBase, IItemStatisticsInfo<IProjectUsageInfo> {
  workbookCount: number;
  datasourceCount: number;
  viewCount: number;
  childProjectCount: number;
}

export interface IProjectDetailInfo extends IProjectBase {
}

export type ProjectDetailWithUsageInfo = IProjectDetailInfo & IItemStatisticsInfo<IProjectUsageInfo>;

export function isIProjectBase(x: any): x is IProjectBase {
  return x.hasOwnProperty('topLevelProject');
}
